import type { ImporteCashFlow, SinFechaCashFlow } from "./api";
import { aCentavos, deCentavos } from "./gastos";

/** Cash flow mensual (docs/modulo-cash-flow.md): textos y sumas para la pantalla. Los montos llegan del backend como
 * texto; las sumas van en centavos con `BigInt`, nunca con float. */

const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

/** "2026-11" → "noviembre 2026". */
export function textoMes(mes: string): string {
  const [anio = "", m = "1"] = mes.split("-");
  return `${MESES[Number(m) - 1] ?? m} ${anio}`;
}

const sumar = (...montos: string[]) => deCentavos(montos.reduce((s, m) => s + aCentavos(m), 0n));

/** Comprometido y estimado, cada uno con sus dos partes. */
export function comprometido(i: ImporteCashFlow): string {
  return sumar(i.comprometido_materiales, i.comprometido_mano_obra);
}

export function estimado(i: ImporteCashFlow): string {
  return sumar(i.estimado_materiales, i.estimado_mano_obra);
}

/** De un pago o estimado sin fecha: materiales y mano de obra (sea comprometido o estimado). */
export function materiales(i: ImporteCashFlow): string {
  return sumar(i.comprometido_materiales, i.estimado_materiales);
}

export function manoDeObra(i: ImporteCashFlow): string {
  return sumar(i.comprometido_mano_obra, i.estimado_mano_obra);
}

export const hayPesos = (i: ImporteCashFlow) => aCentavos(i.ars) !== 0n;

/** "Corralón Norte (Albañilería) · Anticipo" o "Pintura › Látex". */
export function textoSinFecha(s: SinFechaCashFlow): string {
  if (s.origen === "comprometido") return `${s.proveedor ?? "Presupuesto"} (${s.etiqueta ?? "—"}) · ${s.concepto ?? "Pago"}`;
  return `${s.rubro ?? "Rubro"} › ${s.descripcion ?? "Ítem"}`;
}

/** "Fee 15 % sobre cada pago y cada estimado". */
export function textoFee(porcentaje: string): string {
  const p = porcentaje.includes(".") ? porcentaje.replace(/\.?0+$/, "") : porcentaje;
  return `${p.replace(".", ",")} % sobre cada pago y cada estimado`;
}
